<template>
  <action :onAction="editUserAction">
    <template v-slot:icon><v-icon class="material-icons-outlined">create</v-icon></template>
    <template v-slot:tooltip><span>Edit the User in WordPress.</span></template>
    <template v-slot:label><span>Edit User</span></template>
  </action>
</template>

<script>
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Action from '@/components/action/Action.vue';

@Component({
  components: {
    Action,
  },
})
export default class EditUserAction extends Action {
  @Prop(Object) user;

  editUserAction() {
    const url = `http://thecornerstonescripturestudy.org/wordpress/wp-admin/user-edit.php?user_id=${this.user.id}`;
    window.open(url, '_blank');
  }
}
</script>
